<template>
  <div class="nebCheckbox"
    :class="{
      selected: value,
      disabled
    }"
  >
    <div class="nebCheckbox-box"
      @click="onClick"
    >
      <neb-icon name="check"
        width="12px"
        height="12px"
        v-show="value"
      ></neb-icon>
    </div>

    <div class="nebCheckbox-label"
      v-show="label !== ''"
    >
      <label @click="onClick">{{ label }}</label>
    </div>
  </div>
</template>

<script>
import NebIcon from '../../Icon'

export default {
  name: 'NebCheckbox',

  components: {
    NebIcon
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick () {
      if (this.disabled) { return }

      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style.scss';

.nebCheckbox.selected {
  .nebCheckbox-box {
    background-color: $tiffany-blue;
    border: none;
  }
}

.nebCheckbox.disabled {
  .nebCheckbox-box {
    border: solid 1px $pinkish-grey;
    cursor: not-allowed;
  }

  .nebCheckbox-label {
    label {
      color: $warm-grey;
    }
  }
}

.nebCheckbox.selected.disabled {
  .nebCheckbox-box {
    background-color: $pale-blue;
    border: none;
    cursor: not-allowed;
  }
}

.nebCheckbox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  &-box {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: solid 1px $slate-grey;
    background-color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    flex-grow: 0;
    flex-shrink: 0;

    .nebIcon {
      color: $white;
    }
  }

  &-label {
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 7px;

    label {
      font-size: 12px;
      font-family: $defaultFont;
      color: $slate-grey;
    }
  }
}
</style>
